<template>
  <div
    class="location-container cursor-pointer column"
    data-testid="chat-abrir-localizacao"
    @click="openMap"
  >
    <div
      ref="map"
      class="map"
    />
    <div
      class="location-details q-pa-sm"
    >
      <div
        v-if="name"
        class="text-weight-medium ellipsis"
      >
        {{ name }}
        <q-tooltip v-if="name.length > 35">
          {{ name }}
        </q-tooltip>
      </div>
      <div
        v-if="address"
        class="location-address text-grey-7 ellipsis"
      >
        {{ address }}
      </div>
      <div
        v-if="url"
        class="location-address text-grey-7 ellipsis"
      >
        {{ url }}
      </div>
    </div>
    <q-tooltip>
      Abrir no Google Maps
    </q-tooltip>
  </div>
</template>

<script>
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import markerIconPng from 'leaflet/dist/images/marker-icon.png'
import markerShadowPng from 'leaflet/dist/images/marker-shadow.png'

const shell = window.shell

export default {
  props: {
    latitude: {
      type: Number,
      required: true
    },
    longitude: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      default: null
    },
    address: {
      type: String,
      default: null
    },
    url: {
      type: String,
      default: null
    }
  },
  mounted () {
    const map = L.map(this.$refs.map, {
      center: [this.latitude, this.longitude],
      zoom: 16,
      zoomControl: false,
      attributionControl: false,
      dragging: false,
      scrollWheelZoom: false
    })

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19
    }).addTo(map)

    const icon = L.icon({
      iconUrl: markerIconPng,
      shadowUrl: markerShadowPng,
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    })

    L.marker([this.latitude, this.longitude], { icon }).addTo(map)
  },
  methods: {
    openMap () {
      shell.openExternal(`https://www.google.com/maps/search/?api=1&query=${this.latitude},${this.longitude}`)
    }
  }
}
</script>

<style lang="sass" scoped>
.location-container
  width: 300px
  border-radius: 10px
  overflow: hidden
  padding: 2px

.map
  width: 100%
  height: 120px

.location-details
  width: 100%

.location-address
  font-size: 12px
  line-height: 1.2
</style>
